import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import MopraSummary from '../components/MopraSummary'
import { withErrorBoundary } from '../errors/ErrorBoundary'

class ItemSummaryContainer extends PureComponent {
  render () {
    const { data } = this.props
    if (!data) {
      return null
    }
    const { ndvi } = data
    return <MopraSummary  data={data} title={'ndvi'} value={`${ndvi} m`} />
  }
}

const mapStateToProps = state => {
  return {
    data: state.data.MopraVector
  }
}

export default withErrorBoundary(connect(mapStateToProps, null)(ItemSummaryContainer))



// WEBPACK FOOTER //
// ./src/containers/MopraSummaryContainer.js